const getEntities = (list, addToList, userId = null) => {
	list.forEach((item) => {
		if (item?.isEnabled) {
			if(userId === null) addToList([item]);
			if(item.entityAdmins.some((admins) => admins.userId === userId)) addToList([item]);
		};
		if (item?.nodes?.length > 0) getEntities(item.nodes, addToList, userId);
	});
};

const mapEntities = ({label, id, entityId, entityAdmins}) => ({label, value: id, id, entityId, entityAdmins, selected: false, disabled: false});

const getAvailableEntityList = (list, mapped = true, userId = null) => {
	const newList = [];
	const addToList = (itemsToAdd) => newList.push(...itemsToAdd);
	getEntities(list, addToList, userId);
	return mapped ? newList.map(mapEntities) : newList;
};

export const getAdminAvailableEntityList = (list, userId) => {
	return getAvailableEntityList(list, true, userId);
};

export default getAvailableEntityList;
